import { Reveal } from './Reveal';

const experienceLogos = [
  { name: 'Humana', src: new URL('../assets/experience/humana.png', import.meta.url).href },
  { name: 'Catalyst', src: new URL('../assets/experience/catalyst.png', import.meta.url).href },
  { name: 'Cigna', src: new URL('../assets/experience/cigna.png', import.meta.url).href },
  { name: 'Lumeris', src: new URL('../assets/experience/lumeris.png', import.meta.url).href },
  { name: 'Magellan', src: new URL('../assets/experience/magellan.png', import.meta.url).href },
  { name: 'Evicore', src: new URL('../assets/experience/evicore.png', import.meta.url).href },
  { name: 'Gainwell', src: new URL('../assets/experience/gainwell.png', import.meta.url).href },
  { name: 'Edifecs', src: new URL('../assets/experience/edifecs.png', import.meta.url).href },
  { name: 'Rackspace', src: new URL('../assets/experience/rackspace.png', import.meta.url).href },
];

export function Credibility() {
  return (
    <section
      className="py-16 bg-white"
      style={{ borderTop: '1px solid rgba(75,85,99,0.1)', borderBottom: '1px solid rgba(75,85,99,0.1)' }}
    >
      <Reveal className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold uppercase tracking-widest text-[#4B5563]/60 mb-8">
          Built by people who ran the systems at
        </p>
        <div className="flex flex-wrap items-center justify-center gap-12">
          {experienceLogos.map((logo, index) => (
            <Reveal
              as="img"
              key={logo.name}
              direction="scale"
              delay={index * 60}
              src={logo.src}
              alt={logo.name}
              className="ph-logo h-9 md:h-10 w-auto"
            />
          ))}
        </div>
      </Reveal>
    </section>
  );
}
